import React__default, { useContext, createContext } from 'react';

const defaultContextValue = false;
const TablistContext = /*#__PURE__*/createContext(defaultContextValue);
function TablistContextProvider({
  isTablist,
  children
}) {
  return /*#__PURE__*/React__default.createElement(TablistContext.Provider, {
    value: isTablist
  }, children);
}
const useTablistContext = () => {
  const isTablist = useContext(TablistContext);
  return {
    isTablist
  };
};

export { TablistContextProvider as T, useTablistContext as u };
//# sourceMappingURL=TablistContext-DrXcHBdK.js.map
